import { styled } from 'styled-components'

const Wrapper = styled.div`
    table {
        word-break: normal;

        th,
        td {
            padding-top: 2px;
            vertical-align: baseline;
        }

        th {
            font-weight: ${(p) => p.theme.font.weight.normal};
            color: ${(p) => p.theme.color.text.grey};
            padding-right: 6px;
        }
    }
`

interface Props {
    vcard: {
        name: string
        value: string
        guid: string
    }[]
}

export const Fields = ({ vcard = [] }: Props) => {
    const hasMultipleFields = vcard.length > 1

    return (
        <Wrapper data-testid="fields">
            {!hasMultipleFields ? (
                <div style={{ textAlign: 'center' }}>{vcard.at(0)?.value}</div>
            ) : (
                <table>
                    <tbody>
                        {vcard.map((field) => (
                            <tr key={field.guid}>
                                <th scope="row">{field.name}</th>
                                <td>{field.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </Wrapper>
    )
}

export default Fields
